<!--<template>-->
<!--  <div class="oae-container"></div>-->
<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: 'OaePage',-->
<!--  mounted() {-->
<!--    // 页面加载后直接跳转到目标网站（当前窗口打开）-->
<!--    window.location.href = 'https://pad.machao.group/';-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->
<!--.oae-container {-->
<!--  width: 100%;-->
<!--  height: 100vh;-->
<!--}-->
<!--</style>-->
<template>
  <!-- 容器占满整个页面，匹配你的布局样式 -->
  <div class="oae-container">
    <!-- 嵌入目标网站，隐藏边框，占满容器 -->
    <iframe
        class="oae-iframe"
        src="https://pad.machao.group/"
        frameborder="0"
        title="Machao Pad"

    sandbox="allow-same-origin allow-scripts allow-forms allow-popups"

    referrerpolicy="no-referrer"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'OaePage',
  // 可选：如果目标网站有路由跳转，监听iframe加载状态避免白屏 ,
  mounted() {
    const iframe = document.querySelector('.oae-iframe');
    iframe.onload = () => {
      console.log('目标网站加载完成');
    };
    // 兜底：如果iframe加载失败，提示用户
    iframe.onerror = () => {
      alert('目标网站加载失败，请检查网络或联系管理员');
    };
  }
};
</script>

<style scoped>
/* 容器适配你的布局，和父页面样式统一 */
.oae-container {
  width: 100%;
  /* 匹配你的布局高度（比如继承父容器高度） */
  height: 100vh; /* 占满整个视口高度 */
  overflow: hidden;
}

/* iframe占满容器，无边界 */
.oae-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>